<script>
  export let data;
  let htmlField = data.htmlSnippet || data.fields.htmlSnippet; // Header strips out fields and passes that directly
</script>

{#if htmlField}
  <div>
    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
    {@html htmlField}
  </div>
{/if}
